module.exports = __webpack_public_path__ + "static/img/dlym.99258fc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dlym.jpg
// module id = Ja5D
// module chunks = 4